<mat-form-field
  appearance="outline"
  class="attention-global-search w-100"
  subscriptSizing="dynamic"
>
  <mat-label>Buscar abonado</mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchCtrl"
    [matAutocomplete]="autoAbonado"
    (keydown.enter)="onEnter($event)"
    aria-label="Buscar abonado"
  />
  <i-tabler matSuffix name="search" class="icon-18 text-muted"></i-tabler>
  <mat-autocomplete
    #autoAbonado="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
    autoActiveFirstOption
  >
    @for (c of (filteredCustomers$ | async) ?? []; track c.id) {
      <mat-option [value]="c">
        <span class="f-w-600">{{ c.firstName }} {{ c.surname }}</span>
        @if (c.docNumber) {
          <span class="text-muted f-s-12 m-l-8">{{ c.docNumber }}</span>
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
